import request from '@/utils/request'

export function getNoticeHistoryList(params) {
  return request({
    url: 'notice/history',
    method: 'get',
    params
  })
}

/**
 * @param {number} id
 * @returns {Promise<import('../types/utils').R<import('../types/api').NoticeHistoryItem>>}
 */
export function getNoticeHistory(id) {
  return request({
    url: 'notice/history/' + id,
    method: 'get'
  })
}

/**
 * 获取消息发送情况总数
 * @param {import('@/types/generated/openapi').paths['/notice/history-statistic']['get']['parameters']['query']} params
 */
export function getNoticeHistoryStatistic(params) {
  return request({
    url: `/notice/history-statistic`,
    method: 'get',
    params: params
  })
}

/**
 * ntc重新发送消息
 * @param {history_id} history_id:[], 历史消息id数组
 */
export function retryNotice(data) {
  return request({
    url: `/notice/history/retry`,
    method: 'post',
    data
  })
}
